import React, { useEffect, useState } from "react";
import "./DataPendaftaranCendekia.css";
import * as XLSX from "xlsx";

const columnHeaders = {
  form_date: "Tgl Daftar",
  "your-name": "Nama Lengkap",
  tempatlahir: "Tempat Lahir",
  tanggallahir: "Tgl. Lahir",
  "your-email": "Email",
  nohp: "Nomor HP",
  sertifikasi: "Sertifikasi",
  Kemnaker: "Sertifikasi Kemnaker",
  BNSP: "Sertifikasi BNSP",
  periode: "Periode",
  ukuranbaju: "Baju",
  namainstansi: "Nama Instansi",
  alamatinstansi: "Alamat Instansi",
  sayamemahami: "Pemahaman Program",
  koderefferal: "Kode Referral",
  ktpcfdb7_file: "KTP",
  cvcfdb7_file: "CV",
  ijazahcfdb7_file: "Ijazah",
  fotocfdb7_file: "Foto",
  paktaintegritascfdb7_file: "Pakta Integritas",
  suratketeranganbekerjacfdb7_file: "Surat Keterangan Bekerja",
  buktipembayarancfdb7_file: "Bukti Pembayaran",
};

const DataPendaftaranCendekia = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);

  useEffect(() => {
    fetch("https://cendekiasolusi.com/api/getData.php")
      .then((response) => response.json())
      .then((data) => {
        setData(data);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
        setLoading(false);
      });
  }, []);

  const handleClearFilters = () => {
    setStartDate("");
    setEndDate("");
  };

  const handleDownloadXLSX = () => {
    if (filteredData.length === 0) {
      alert("Tidak ada data yang dapat diunduh!");
      return;
    }

    const baseURL = "https://cendekiasolusi.com/wp-content/uploads/cfdb7_uploads/";

    const excelData = filteredData.map((row, index) => ({
      "No Urut": index + 1,
      "Tgl Daftar": new Date(row.form_date).toLocaleDateString("id-ID"),
      ...Object.fromEntries(
        Object.entries(row.form_value)
          .filter(([key]) => key !== "cfdb7_status")
          .map(([key, value]) => [
            columnHeaders[key] || key,
            key.includes("cfdb7_file") && value
              ? baseURL + value
              : Array.isArray(value)
              ? value.join(", ")
              : String(value) || "-",
          ])
      ),
    }));

    const worksheet = XLSX.utils.json_to_sheet(excelData);

    Object.keys(worksheet).forEach((cell) => {
      if (worksheet[cell].v && typeof worksheet[cell].v === "string" && worksheet[cell].v.startsWith(baseURL)) {
        worksheet[cell].l = { Target: worksheet[cell].v, Tooltip: "Klik untuk membuka file" };
      }
    });

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Data Pendaftaran");

    XLSX.writeFile(workbook, "Data_Pendaftaran.xlsx");
  };

  const filteredData = data.filter((row) => {
    const formDate = new Date(row.form_date);
    const start = startDate ? new Date(startDate) : null;
    const end = endDate ? new Date(endDate) : null;
    return (!start || formDate >= start) && (!end || formDate <= end);
  });

  const handleOpenModal = (fileUrl) => {
    setSelectedFile(fileUrl);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setSelectedFile(null);
  };

  if (loading) {
    return <p className="data-pengguna-loading">Loading data...</p>;
  }

  return (
    <div className="data-pengguna-container">
      <div className="data-pengguna-header" style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <h2>Data Pendaftaran Pelatihan</h2>
        <div style={{ display: "flex", gap: "10px" }}>
          <div>
            <small>Filter Tanggal :</small>
            <div>
              <label>
                <input style={{marginRight:'5px'}} type="date" value={startDate} onChange={(e) => setStartDate(e.target.value)} />
              </label>
              <label>
                - 
                <input style={{margin:'0px 5px'}} type="date" value={endDate} onChange={(e) => setEndDate(e.target.value)} />
              </label>
            </div>
          </div>
          <button onClick={handleClearFilters} style={{ padding: "8px 16px", backgroundColor: "#dc3545", color: "white", border: "none", borderRadius: "5px", cursor: "pointer" }}>
            Show All
          </button>
          <button style={{ padding: "8px 16px", backgroundColor: "#007bff", color: "white", border: "none", borderRadius: "5px" }}>
            Jml Data: {filteredData.length}
          </button>
          <button onClick={handleDownloadXLSX} style={{ padding: "8px 16px", backgroundColor: "#28a745", color: "white", border: "none", borderRadius: "5px", cursor: "pointer" }}>
            Download XLSX
          </button>
        </div>
      </div>

      <div className="data-pengguna-table-wrapper">
        {filteredData.length > 0 ? (
          <table className="data-pengguna-table">
            <thead>
              <tr>
                <th>No Urut</th>
                <th>{columnHeaders.form_date}</th>
                {Object.keys(data[0].form_value)
                  .filter((key) => key !== "cfdb7_status")
                  .map((key) => (
                    <th key={key}>{columnHeaders[key] || key}</th>
                  ))}
              </tr>
            </thead>
            <tbody>
              {filteredData.map((row, index) => (
                <tr key={index}>
                  <td style={{textAlign:'center'}}>{index + 1}</td>
                  <td>{new Date(row.form_date).toLocaleDateString("id-ID")}</td>
                  {Object.entries(row.form_value)
                    .filter(([key]) => key !== "cfdb7_status")
                    .map(([key, value]) => {
                      if (key === "nohp") {
                        let formattedPhone = value;
                        if (formattedPhone.startsWith("0")) {
                          formattedPhone = "+62" + formattedPhone.substring(1);
                        } else if (formattedPhone.startsWith("62")) {
                          formattedPhone = "+62" + formattedPhone.substring(2);
                        }
                        return (
                          <td key={key}>
                            <a
                              href={`https://wa.me/${formattedPhone.replace(/\D/g, "")}`}
                              target="_blank"
                              rel="noopener noreferrer"
                              style={{ color: "blue", textDecoration: "none", fontWeight: "bold" }}
                            >
                              {formattedPhone}
                            </a>
                          </td>
                        );
                      }

                      return (
                        <td key={key}>
                          {key.toLowerCase().includes("tanggallahir") ? (
                            new Date(value).toLocaleDateString("id-ID")
                          ) : key.includes("cfdb7_file") && value ? (
                            <button
                              onClick={() => handleOpenModal(`https://cendekiasolusi.com/wp-content/uploads/cfdb7_uploads/${value}`)}
                              style={{
                                padding: "5px 10px",
                                backgroundColor: "#007bff",
                                color: "white",
                                border: "none",
                                borderRadius: "5px",
                                cursor: "pointer",
                              }}
                            >
                              Lihat
                            </button>
                          ) : Array.isArray(value) ? (
                            value.join(", ")
                          ) : (
                            value
                          )}
                        </td>
                      );
                    })}
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <p className="data-pengguna-loading">Tidak ada data ditemukan.</p>
        )}
      </div>

      <Modal isOpen={isModalOpen} onClose={handleCloseModal} fileUrl={selectedFile} />
    </div>
  );
};

const Modal = ({ isOpen, onClose, fileUrl }) => {
  if (!isOpen) return null;

  // Ekstrak nama file dari URL
  const fileName = fileUrl.split("/").pop();

  return (
    <div style={styles.modalOverlay}>
      <div style={styles.modalContent}>
        <span style={styles.closeButton} onClick={onClose}>&times;</span>
        <iframe src={fileUrl} style={styles.iframe} title="File Preview" />
        <div style={styles.buttonContainer}>
          <a
            href={fileUrl}
            download={fileName} // Memaksa browser mengunduh file
            style={styles.downloadButton}
            target="_blank"
            rel="noopener noreferrer"
          >
            Open File
          </a>
        </div>
      </div>
    </div>
  );
};

const styles = {
  modalOverlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 1000,
  },
  modalContent: {
    backgroundColor: '#fff',
    padding: '20px',
    borderRadius: '5px',
    width: '80%',
    height: '80%',
    position: 'relative',
  },
  closeButton: {
    position: 'absolute',
    top: '10px',
    right: '10px',
    cursor: 'pointer',
    fontSize: '24px',
  },
  iframe: {
    width: '100%',
    height: '85%',
    border: 'none',
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: '10px',
  },
  downloadButton: {
    padding: '10px 20px',
    backgroundColor: '#28a745',
    color: 'white',
    border: 'none',
    borderRadius: '5px',
    cursor: 'pointer',
    textDecoration: 'none',
  },
};

export default DataPendaftaranCendekia;